import { useParams } from 'react-router-dom'
import { SellerShops as SellerShopsComponent } from 'components/sellers/SellerShops/SellerShops'

export const SellerShops: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  return <SellerShopsComponent type='seller' sellerId={id as string} />
}